/**
 * Item Emoji Mapper
 * Maps shopping item names to relevant emojis for visual appeal
 */

const ITEM_EMOJI_MAP = {
  // Fruits
  'apple': '🍎',
  'apples': '🍎',
  'banana': '🍌',
  'bananas': '🍌',
  'orange': '🍊',
  'oranges': '🍊',
  'grape': '🍇',
  'grapes': '🍇',
  'strawberry': '🍓',
  'strawberries': '🍓',
  'blueberry': '🫐',
  'blueberries': '🫐',
  'lemon': '🍋',
  'lemons': '🍋',
  'lime': '🍋‍🟩',
  'limes': '🍋‍🟩',
  'avocado': '🥑',
  'avocados': '🥑',
  'plantain': '🍌',
  'plantains': '🍌',
  'pawpaw': '🥭',
  'papaya': '🥭',
  'mango': '🥭',
  'mangoes': '🥭',
  'pineapple': '🍍',
  'watermelon': '🍉',
  'coconut': '🥥',
  'cherry': '🍒',
  'cherries': '🍒',
  'peach': '🍑',
  'peaches': '🍑',
  'pear': '🍐',
  'pears': '🍐',
  'kiwi': '🥝',
  
  // Vegetables
  'tomato': '🍅',
  'tomatoes': '🍅',
  'carrot': '🥕',
  'carrots': '🥕',
  'broccoli': '🥦',
  'cucumber': '🥒',
  'cucumbers': '🥒',
  'lettuce': '🥬',
  'spinach': '🥬',
  'kale': '🥬',
  'cabbage': '🥬',
  'corn': '🌽',
  'pepper': '🌶️',
  'peppers': '🌶️',
  'bell pepper': '🫑',
  'bell peppers': '🫑',
  'scotch bonnet': '🌶️',
  'chilli': '🌶️',
  'chillies': '🌶️',
  'mushroom': '🍄',
  'mushrooms': '🍄',
  'eggplant': '🍆',
  'aubergine': '🍆',
  'garden eggs': '🍆',
  'okra': '🫛',
  'onion': '🧅',
  'onions': '🧅',
  'garlic': '🧄',
  'potato': '🥔',
  'potatoes': '🥔',
  'sweet potato': '🍠',
  'sweet potatoes': '🍠',
  'yam': '🍠',
  'cassava': '🍠',
  'ginger': '🫚',
  'beans': '🫘',
  'peas': '🫛',
  
  // African Greens
  'ugu': '🥬',
  'ewedu': '🥬',
  'bitterleaf': '🥬',
  'okazi': '🥬',
  'sukuma wiki': '🥬',
  
  // Meat & Poultry
  'chicken': '🍗',
  'chicken breast': '🍗',
  'chicken breasts': '🍗',
  'whole chicken': '🍗',
  'turkey': '🦃',
  'beef': '🥩',
  'steak': '🥩',
  'pork': '🥓',
  'bacon': '🥓',
  'sausage': '🌭',
  'sausages': '🌭',
  'hot dog': '🌭',
  'hot dogs': '🌭',
  'lamb': '🍖',
  'goat': '🍖',
  'goat meat': '🍖',
  'meat': '🍖',
  'ham': '🍖',
  'ponmo': '🍖',
  'shaki': '🍖',
  'tripe': '🍖',
  'cow tail': '🍖',
  'cow foot': '🍖',
  
  // Seafood
  'fish': '🐟',
  'salmon': '🐟',
  'tuna': '🐟',
  'tilapia': '🐟',
  'cod': '🐟',
  'catfish': '🐟',
  'stockfish': '🐟',
  'shrimp': '🦐',
  'prawns': '🦐',
  'crab': '🦀',
  'lobster': '🦞',
  
  // Dairy
  'milk': '🥛',
  'whole milk': '🥛',
  'skim milk': '🥛',
  'almond milk': '🥛',
  'oat milk': '🥛',
  'soy milk': '🥛',
  'cheese': '🧀',
  'cheddar': '🧀',
  'mozzarella': '🧀',
  'parmesan': '🧀',
  'butter': '🧈',
  'yogurt': '🥛',
  'cream': '🥛',
  'egg': '🥚',
  'eggs': '🥚',
  'ice cream': '🍦',
  
  // Bread & Grains
  'bread': '🍞',
  'sandwich bread': '🍞',
  'bagel': '🥯',
  'bagels': '🥯',
  'croissant': '🥐',
  'baguette': '🥖',
  'rice': '🍚',
  'white rice': '🍚',
  'brown rice': '🍚',
  'jollof': '🍚',
  'ofada rice': '🍚',
  'pasta': '🍝',
  'spaghetti': '🍝',
  'noodles': '🍜',
  'oats': '🥣',
  'cereal': '🥣',
  'flour': '🌾',
  'garri': '🌾',
  'pounded yam': '🌾',
  'fufu': '🌾',
  'tortilla': '🫓',
  'tortillas': '🫓',
  'pancake': '🥞',
  'pancakes': '🥞',
  'waffle': '🧇',
  'waffles': '🧇',
  
  // Pantry
  'salt': '🧂',
  'sugar': '🍬',
  'honey': '🍯',
  'oil': '🫒',
  'olive oil': '🫒',
  'vegetable oil': '🫒',
  'palm oil': '🫒',
  'vinegar': '🫒',
  'ketchup': '🍅',
  'mayonnaise': '🥫',
  'mustard': '🟡',
  'soy sauce': '🥫',
  'hot sauce': '🌶️',
  'black pepper': '🧂',
  'spice': '🌶️',
  'maggi': '🧂',
  'knorr': '🧂',
  'suya spice': '🌶️',
  'crayfish': '🦐',
  'egusi': '🌰',
  'ogbono': '🌰',
  'peanut butter': '🥜',
  'groundnut': '🥜',
  'jam': '🍯',
  'soup': '🥫',
  'tomato paste': '🍅',
  'canned': '🥫',
  
  // Beverages
  'water': '💧',
  'sparkling water': '💧',
  'juice': '🧃',
  'coffee': '☕',
  'tea': '🍵',
  'soda': '🥤',
  'coke': '🥤',
  'pepsi': '🥤',
  'beer': '🍺',
  'wine': '🍷',
  'spirits': '🥃',
  'whiskey': '🥃',
  
  // Frozen
  'pizza': '🍕',
  'frozen': '🧊',
  
  // Household
  'soap': '🧼',
  'dish soap': '🧼',
  'body wash': '🧴',
  'shampoo': '🧴',
  'conditioner': '🧴',
  'lotion': '🧴',
  'toothpaste': '🪥',
  'toothbrush': '🪥',
  'detergent': '🧺',
  'laundry': '🧺',
  'cleaner': '🧹',
  'bleach': '🧴',
  'paper towel': '🧻',
  'paper towels': '🧻',
  'toilet paper': '🧻',
  'tissue': '🧻',
  'tissues': '🧻',
  'trash bag': '🗑️',
  'trash bags': '🗑️',
  'foil': '📄',
  'aluminum foil': '📄',
  'plastic wrap': '📄',
  'battery': '🔋',
  'batteries': '🔋',
  'light bulb': '💡',
  'light bulbs': '💡',
  'deodorant': '🧴',
  'razor': '🪒',
  'band-aid': '🩹',
  'band-aids': '🩹',
  'medicine': '💊',
  'pain reliever': '💊',
  'vitamins': '💊',
};

// Category-based fallback emojis
const CATEGORY_EMOJI_MAP = {
  'fruits': '🍎',
  'vegetables': '🥬',
  'vegetables & leafy greens': '🥬',
  'tubers': '🥔',
  'tubers & roots': '🥔',
  'aromatics': '🧅',
  'aromatics & peppers': '🌶️',
  'poultry': '🍗',
  'red meat': '🥩',
  'red meat & assorted meats': '🥩',
  'processed': '🌭',
  'processed / deli': '🌭',
  'seafood': '🐟',
  'fresh & frozen seafood': '🐟',
  'dried & smoked seafood': '🐟',
  'milk': '🥛',
  'milk & cream': '🥛',
  'cheese': '🧀',
  'cultured dairy': '🥛',
  'plant-based': '🥛',
  'plant-based alternatives': '🥛',
  'bread': '🍞',
  'bread & wraps': '🍞',
  'rice': '🍚',
  'rice & grains': '🍚',
  'flours': '🌾',
  'flours & fufu bases': '🌾',
  'legumes': '🫘',
  'legumes & beans': '🫘',
  'oils': '🫒',
  'oils & vinegar': '🫒',
  'canned': '🥫',
  'canned & jarred foods': '🥫',
  'spices': '🌶️',
  'spices & seasonings': '🌶️',
  'soup thickeners': '🌰',
  'soup thickeners & fermented condiments': '🌰',
  'baking': '🧁',
  'baking essentials': '🧁',
  'condiments': '🥫',
  'condiments & sauces': '🥫',
  'frozen': '🧊',
  'frozen items': '🧊',
  'beverages': '🥤',
  'non-alcoholic': '🥤',
  'non-alcoholic beverages': '🥤',
  'alcoholic': '🍺',
  'alcoholic beverages': '🍺',
  'cleaning': '🧹',
  'cleaning supplies': '🧹',
  'paper': '🧻',
  'paper goods': '🧻',
  'storage': '📦',
  'storage & miscellaneous': '📦',
  'personal care': '🧴',
  'personal care & health': '🧴',
  'household': '🏠',
  'fresh produce': '🥬',
  'fresh produce, vegetables & tubers': '🥬',
  'meat': '🥩',
  'meat, poultry & seafood': '🥩',
  'dairy': '🥛',
  'dairy & dairy alternatives': '🥛',
  'grains': '🍚',
  'grains, rice, flours & fufu bases': '🍚',
  'pantry': '🫒',
  'pantry staples': '🫒',
  'pantry staples, oils & seasonings': '🫒',
  'frozen foods': '🧊',
  'frozen foods & beverages': '🧊',
  'household supplies': '🧹',
  'household supplies & personal care': '🧹',
};

/**
 * Get emoji for an item based on its name and/or category
 * @param {string} itemName - The item name
 * @param {string} category - The item category (optional)
 * @param {string} subcategory - The item subcategory (optional)
 * @returns {string} The matching emoji or default shopping cart
 */
export function getItemEmoji(itemName, category = '', subcategory = '') {
  // Normalize the item name
  const normalizedName = itemName?.toLowerCase().trim() || '';
  
  // Try exact match first
  if (ITEM_EMOJI_MAP[normalizedName]) {
    return ITEM_EMOJI_MAP[normalizedName];
  }
  
  // Try partial match (item name contains a known word)
  for (const [key, emoji] of Object.entries(ITEM_EMOJI_MAP)) {
    if (normalizedName.includes(key) || key.includes(normalizedName)) {
      return emoji;
    }
  }
  
  // Try subcategory fallback
  const normalizedSubcategory = subcategory?.toLowerCase().trim() || '';
  if (CATEGORY_EMOJI_MAP[normalizedSubcategory]) {
    return CATEGORY_EMOJI_MAP[normalizedSubcategory];
  }
  
  // Try category fallback
  const normalizedCategory = category?.toLowerCase().trim() || '';
  if (CATEGORY_EMOJI_MAP[normalizedCategory]) {
    return CATEGORY_EMOJI_MAP[normalizedCategory];
  }
  
  // Default emoji
  return '🛒';
}

export default getItemEmoji;
